export default "__VITE_ASSET__1a2f582f__"